import React, { Suspense } from "react";

import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import { Router } from "react-router-dom";

import { localizationService } from "@state";

import { GlobalLoader } from "../components/global-loader/GlobalLoader";
import ReactApp from "./App";

if (module.hot) module.hot.accept();

ReactDOM.render(
	<Suspense fallback={<GlobalLoader />}>
		<Router history={App.state.history}>
			<I18nextProvider i18n={localizationService}>
				<ReactApp />
			</I18nextProvider>
		</Router>
	</Suspense>,
	document.getElementById("app")
);
